<template>
  <transition name="fade">
    <div v-if="visible" class="el-message" :class="[typeClass, customClass]" @mouseenter="clearTimer" @mouseleave="restartTimer">
      <div class="el-message__content">
        <span v-if="showIcon" class="el-message__icon" :class="iconClass">{{ iconText }}</span>
        <span class="el-message__text" v-html="message"></span>
        <i v-if="showClose" class="el-message__close" @click="close">✕</i>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Message',
  props: {
    message: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'info'
    },
    duration: {
      type: Number,
      default: 3000
    },
    showClose: {
      type: Boolean,
      default: false
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    customClass: {
      type: String,
      default: ''
    },
    onClose: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      visible: false,
      timer: null
    }
  },
  computed: {
    typeClass () {
      return `el-message--${this.type}`
    },
    iconClass () {
      const iconMap = {
        success: 'el-icon-success',
        warning: 'el-icon-warning',
        error: 'el-icon-error',
        info: 'el-icon-info'
      }
      return iconMap[this.type] || 'el-icon-info'
    },
    iconText () {
      const textMap = {
        success: '✓',
        warning: '!',
        error: '✕',
        info: 'i'
      }
      return textMap[this.type] || 'i'
    }
  },
  methods: {
    close () {
      this.visible = false
      this.clearTimer()
      if (typeof this.onClose === 'function') {
        this.onClose()
      }
      // 移除 DOM 节点（由调用方管理）
      this.$destroy()
      this.$el.parentNode && this.$el.parentNode.removeChild(this.$el)
    },
    clearTimer () {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
    },
    restartTimer () {
      if (this.duration > 0) {
        this.clearTimer()
        this.timer = setTimeout(this.close, this.duration)
      }
    }
  },
  mounted () {
    if (this.duration > 0) {
      this.timer = setTimeout(this.close, this.duration)
    }
    // 将实例挂载到 body
    document.body.appendChild(this.$el)
  },
  beforeDestroy () {
    this.clearTimer()
  }
}
</script>

<style scoped>
/* 提示框基础样式 */
.el-message {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  min-width: 300px;
  max-width: 80%;
  padding: 12px 20px;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  font-size: 14px;
  line-height: 1.5;
  display: flex;
  align-items: center;
  transition: opacity 0.3s, transform 0.3s;
  background: #fff;
  border: 1px solid #ebeef5;
  color: #606266;
}

.el-message__content {
  display: flex;
  align-items: center;
  width: 100%;
}

.el-message__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin-right: 8px;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  flex-shrink: 0;
}

.el-message__text {
  flex: 1;
  word-break: break-word;
}

.el-message__close {
  margin-left: 12px;
  cursor: pointer;
  font-size: 14px;
  color: #909399;
  transition: color 0.2s;
  flex-shrink: 0;
}

.el-message__close:hover {
  color: #409eff;
}

/* 类型颜色 */
.el-message--success {
  border-color: #c2e7b0;
  border-left: 4px solid #67c23a;
  background: #f0f9eb;
  color: #67c23a;
}

.el-message--success .el-message__icon {
  background: #67c23a;
  color: #fff;
}

.el-message--warning {
  border-color: #f3d19e;
  border-left: 4px solid #e6a23c;
  background: #fdf6ec;
  color: #e6a23c;
}

.el-message--warning .el-message__icon {
  background: #e6a23c;
  color: #fff;
}

.el-message--error {
  border-color: #fab6b6;
  border-left: 4px solid #f56c6c;
  background: #fef0f0;
  color: #f56c6c;
}

.el-message--error .el-message__icon {
  background: #f56c6c;
  color: #fff;
}

.el-message--info {
  border-color: #d3d4d6;
  border-left: 4px solid #909399;
  background: #f4f4f5;
  color: #909399;
}

.el-message--info .el-message__icon {
  background: #909399;
  color: #fff;
}

/* 过渡动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-20px);
}
</style>



// WEBPACK FOOTER //
// src/components/Message.vue